/* Customer support surface — English catalog. */
window.PlummeI18n.register('en', {
  'nav.support': 'Support',
  'navhelp.support': 'View and follow up the support tickets you have submitted.',
  'route.support': 'Support',
  'support.title': 'Support',
  'support.contact': 'Contact support',
  'support.close': 'Close',
  'support.send': 'Send',
  'support.sending': 'Sending…',
  'support.editor.toolbar': 'Message formatting',
  'support.editor.bold': 'Bold',
  'support.editor.italic': 'Italic',
  'support.editor.underline': 'Underline',
  'support.editor.bullets': 'Bulleted list',
  'support.editor.numbered': 'Numbered list',
  'support.editor.list': 'List',
  'support.editor.link': 'Link',
  'support.editor.linkPrompt': 'Paste an http:// or https:// link',
  'support.editor.image': 'Image',
  'support.editor.screenshot': 'Screenshot',
  'support.editor.screenshotLabel': 'Attach a screenshot of the current view',
  'support.editor.capturing': 'Taking screenshot…',
  'support.editor.pendingImages': 'Images ready to send',
  'support.editor.removeImage': 'Remove image',
  'support.editor.openImage': 'Open image',
  'support.editor.optimizing': 'Optimizing images…',
  'support.retry': 'Try again',
  'support.back': 'Back to support tickets',
  'support.category': 'Category',
  'support.category.feil': 'Bug / something is not working',
  'support.category.fakturering': 'Billing and payment',
  'support.category.sporsmal': 'General question',
  'support.category.annet': 'Other',
  'support.subject': 'Subject',
  'support.subject.placeholder': 'Short description of the issue',
  'support.message': 'Message',
  'support.message.placeholder': 'Describe what is happening, preferably with details',
  'support.sent.title': 'Support ticket sent',
  'support.sent.text': 'We have received {id} and will get back to you as soon as possible.',
  'support.new.title': 'New support ticket',
  'support.new.action': 'New ticket',
  'support.filter.label': 'Filter support tickets',
  'support.filter.all': 'All',
  'support.filter.open': 'Open',
  'support.filter.closed': 'Closed',
  'support.table.ticket': 'Ticket',
  'support.table.category': 'Category',
  'support.table.sent': 'Sent',
  'support.table.lastReply': 'Last reply',
  'support.lastReply.you': 'You',
  'support.lastReply.support': 'Support',
  'support.table.status': 'Status',
  'support.status.open': 'Open',
  'support.status.closed': 'Closed',
  'support.opened': 'Opened {date}',
  'support.closeTicket': 'Mark as closed',
  'support.table.actions': 'Actions',
  'support.delete.rowAction': 'Delete',
  'support.delete.rowLabel': 'Delete ticket {{id}}',
  'support.delete.action': 'Delete ticket',
  'support.delete.title': 'Delete this ticket?',
  'support.delete.confirm': 'Delete',
  'support.delete.text': 'The ticket will be removed from your list and its messages will no longer be accessible to you.',
  'support.delete.done': 'The ticket was deleted.',
  'support.error.delete': 'The ticket could not be deleted. Try again.',
  'support.reopen.action': 'Reopen',
  'support.reopen.title': 'Reopen the support ticket?',
  'support.reopen.confirm': 'Reopen anyway',
  'support.reopen.text': 'Only reopen the ticket if it concerns the same issue. If this is a new issue, create a new support ticket instead.',
  'support.you': 'You',
  'support.agent': 'Support',
  'support.reply.placeholder': 'Continue the conversation – write a message to support',
  'support.closed.note': 'This ticket is closed. You can view its history, but you cannot send more messages.',
  'support.empty.title': 'No support tickets yet',
  'support.empty.filterTitle': 'No tickets in this filter',
  'support.empty.text': 'Tickets you submit through the support button will appear here.',
  'support.loading.list': 'Loading support tickets…',
  'support.loading.thread': 'Loading the conversation…',
  'support.error.required': 'Enter both a subject and a message.',
  'support.error.noBusiness': 'Select a business before contacting support.',
  'support.error.create': 'The support ticket could not be sent. Try again.',
  'support.error.list': 'The support tickets could not be loaded.',
  'support.error.thread': 'The conversation could not be loaded.',
  'support.error.reply': 'The message could not be sent. Try again.',
  'support.error.status': 'The ticket status could not be updated.',
  'support.error.link': 'Enter a valid http:// or https:// link.',
  'support.error.imageType': 'Use JPEG, PNG, GIF, or WebP images.',
  'support.error.imageSourceSize': 'Each source image must be 20 MB or smaller.',
  'support.error.imageSourceTotal': 'Source images can total at most 40 MB per selection.',
  'support.error.imageCount': 'You can attach up to four images.',
  'support.error.imageSize': 'An image is still larger than 5 MB after optimization.',
  'support.error.imageTotal': 'Optimized images can total at most 10 MB per message.',
  'support.error.imageOptimize': 'The image could not be optimized. Try a smaller image.',
  'support.error.screenshot': 'The screenshot could not be taken. Try again or attach an image manually.',
  'support.error.imagesUnavailable': 'Image sending requires the updated support service. Reload and try again.',
  'support.error.requestTimedOut': 'The support service did not respond. Try again.',
  'support.page.tickets': 'Tickets',
  'support.page.articles': 'Articles',
  'support.articles.back': 'Back to articles',
  'support.articles.search.label': 'Search help articles',
  'support.articles.categories': 'Categories',
  'support.articles.results': 'Articles found: {count}',
  'support.articles.empty.title': 'No articles found',
  'support.articles.empty.text': 'Try a different search term or choose another category.',
  'support.articles.clear': 'Clear search and filter',
  'support.pages.label': 'Choose support page',
  'support.articles.search.placeholder': 'Search help articles',
  'support.articles.count.one': '{count} article',
  'support.articles.count.other': '{count} articles',
  'support.articles.resultsTitle': 'Search results',
});

window.PlummeI18n.register('en', {
  "err.nativeValidation.backend-support.1": "Invalid support deletion response.",
});
